import type { ContentBlock, ContentBlockContent, FaqContent, GalleryContent, GreetingsContent, PublicMessageBoardContent, RsvpContent, WeddingDayContent } from 'weddings/api/weddings'

export function getGreetingsContentBlock(contentBlocks?: Array<ContentBlock<ContentBlockContent>>) {
  return contentBlocks?.find(b => b.type === 'GREETINGS') as ContentBlock<GreetingsContent> | undefined
}

export function getWeddingDayDetailsContentBlock(contentBlocks?: Array<ContentBlock<ContentBlockContent>>) {
  return contentBlocks?.find(b => b.type === 'WEDDING_DAY_DETAILS') as ContentBlock<WeddingDayContent> | undefined
}

export function getRsvpFormContentBlock(contentBlocks?: Array<ContentBlock<ContentBlockContent>>) {
  return contentBlocks?.find(b => b.type === 'RSVP_FORM') as ContentBlock<RsvpContent> | undefined
}

export function getGalleryContentBlock(contentBlocks?: Array<ContentBlock<ContentBlockContent>>) {
  return contentBlocks?.find(b => b.type === 'GALLERY') as ContentBlock<GalleryContent> | undefined
}

export function getPublicMessageBoardContentBlock(contentBlocks?: Array<ContentBlock<ContentBlockContent>>) {
  return contentBlocks?.find(b => b.type === 'PUBLIC_MESSAGE_BOARD') as ContentBlock<PublicMessageBoardContent> | undefined
}

export function getFaqsContentBlock(contentBlocks?: Array<ContentBlock<ContentBlockContent>>) {
  return contentBlocks?.find(b => b.type === 'FAQ') as ContentBlock<FaqContent> | undefined
}
